<script setup lang="ts">
import { SyncOutlined } from '@ant-design/icons-vue'
import { ref, computed } from 'vue'

import { useLinkedFarmInvitationsWithLinkedFarms } from '@/composables/linkedFarmInvitations'

const props = defineProps<{
  showEditInviteModal: boolean
  inviteId: string
}>()

const submittingEdits = ref(false)
const emit = defineEmits(['close-modal'])

const { invitations, patchInvitation } = useLinkedFarmInvitationsWithLinkedFarms()

const invite = computed(() => {
  return invitations.value?.find((i) => i.invite.id === props.inviteId)
})

const newReference = ref(invite.value?.invite.clientReferenceId ?? '')

async function editInvite() {
  if (!invite.value) return
  submittingEdits.value = true
  await patchInvitation(invite.value.invite.id, {
    clientReferenceId: newReference.value,
  })
  submittingEdits.value = false
  closeModal()
}

function handleCancel() {
  closeModal()
}

function closeModal() {
  emit('close-modal')
}

const referenceHasChanged = computed(() => {
  return newReference.value !== invite.value?.invite.clientReferenceId
})
</script>

<template>
  <AModal
    :open="showEditInviteModal"
    title="Edit Recipient Details"
    :destroy-on-close="true"
    :footer="null"
    @cancel="handleCancel"
  >
    <p v-if="invite && 'id' in invite.recipientDetails">
      <strong>Invite Recipient:</strong> {{ invite.recipientDetails.firstName }}
      {{ invite.recipientDetails.lastName }}
    </p>

    <AFormItem label="Reference ID" class="mt-4">
      <AInput v-model:value="newReference" />
    </AFormItem>

    <AFlex justify="flex-end" class="gap-x-6">
      <AButton @click="handleCancel"> Cancel </AButton>

      <AButton
        id="submitCohortBtn"
        type="primary"
        :disabled="!referenceHasChanged"
        @click="editInvite"
      >
        <sync-outlined v-if="submittingEdits" spin />
        Submit
      </AButton>
    </AFlex>
  </AModal>
</template>
